import { Injectable } from '@angular/core';
//import { environment } from "src/environments/environment";

const browser_session = "browser_session";
const access_token = 'token';
const refresh_token = 'refreshToken';
const vehicle_chassis_token = 'selectedVehicleID';
const app_name = 'appName';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  //APIConstants: any = environment;
  
  constructor() { }

  getToken(): any {
    var val = localStorage.getItem(access_token);
    if(val && val.length>0){
    return btoa(val);
    } else {
      return "";
    }
  }

  getRefreshToken(): any {
    var val = localStorage.getItem(refresh_token);
    if(val && val.length>0){
    return btoa(val);
    } else {
      return "";
    }
  }

  getsessionToken(key:string){
    return localStorage.getItem(key);
  }

  saveAppName(appName:string):void{
    localStorage.setItem(app_name, appName);
}

  saveToken(token:string): void {
    localStorage.setItem(access_token, token);
  }

saveRefreshToken(refreshTkn:string): void {
    localStorage.setItem(refresh_token, refreshTkn);
  }

  setVehicleChassisToken(selectedVehicleID:string):void{
    localStorage.setItem(vehicle_chassis_token,selectedVehicleID);
  }

  removeToken(): void {

    localStorage.removeItem(access_token);
  }

  removeRefreshToken(): void {
   
    localStorage.removeItem(refresh_token);
  }

  removeVehicleChassisToken():void{
    localStorage.removeItem(vehicle_chassis_token);
  }

  getBrowserInstance(): any {
    return localStorage.getItem(browser_session);
  }

  setBrowserInstance(value:any): void {
    localStorage.setItem(browser_session, value);
  }

  clearToken(): void {
    localStorage.removeItem('access_token');
  }

  isLoggedIn(): boolean {
    return !!this.getToken(); // Returns true if token exists
  }

  checkValidateToken(token:any): boolean {
    
    return true;
   if(token==refresh_token)
   {
    return true;
   }
   return false;
  }

}
